import React from 'react';
import './PrivacyPolicy.css';

export const PrivacyPolicy = () => {
	return <>
		<iframe className="privacy-policy" title="Podmínky" src="./privacy-policy.html" />
	</>;
};
